module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "header": 'Oops!',
      "headerStyle": 'font-weight: bold; font-size: 24px',
      "maxWidth": '600px',
      "padding": '20px'
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleModalClose.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "center-xs"
  }, [_c('div', {
    staticClass: "mt3 pl-subheading"
  }, [_vm._v("\n      Your school needs to purchase additional teacher licenses to upgrade\n      your account. Please contact one of the Parlay administrators from your\n      school.\n    ")]), _vm._v(" "), (_vm.adminUsersOfSchool.length) ? _c('div', {
    staticClass: "mt4 admin-users"
  }, _vm._l((_vm.adminUsersOfSchool), function(user) {
    return _c('div', {
      key: user.name
    }, [_vm._v("\n        " + _vm._s(user.name) + " - " + _vm._s(user.email) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px",
      "padding": "6px 18px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleModalClose.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Okay, got it!\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5a75ff8b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/upgradeBlockModalViews/upgradeBlockModal.vue
// module id = 2423
// module chunks = 61